import { render, staticRenderFns } from "./ZoomWeb.vue?vue&type=template&id=6f7a8b37&"
import script from "./ZoomWeb.vue?vue&type=script&lang=js&"
export * from "./ZoomWeb.vue?vue&type=script&lang=js&"
import style0 from "./ZoomWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports